import ModuleContent from "features/shared/layout/content/ModuleContent";
import Header from "features/shared/layout/header/Header";
import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import Ets2AffidavitSignAcceptSection from "../sections/Ets2AffidavitSignAcceptSection";

type RouteProps = {
  ets2AffidavitId: string;
};

const Ets2AffidavitSignAcceptPage = () => {
  // translations
  const tLabels = useTranslation("shared\\moduleNames").t;

  // router
  const { ets2AffidavitId } = useParams<RouteProps>();

  // render
  return (
    <>
      <Header
        title={tLabels("ets2AffidavitSignAcceptPage.title")}
        includeBreadcrumbs
        links={[{ text: tLabels('ets2Affidavits.title'), to: '/ets2-affidavit' }]}
      />
      <ModuleContent>
        <Ets2AffidavitSignAcceptSection ets2AffidavitId={ets2AffidavitId} />
      </ModuleContent>
    </>
  );
};

export default Ets2AffidavitSignAcceptPage;
